export default "__VITE_ASSET__4atfUPl0__"